import url from 'App/Root/url'
import getAuthHeaders from 'App/helpers/auth/getAuthHeaders'
import download from 'downloadjs'

export default async function (params, route, fileName) {
  const body = JSON.stringify(params)

  const response = await fetch(`${url}/${route}`, {
    method: 'POST',
    dataType: 'binary',
    body,
    headers: getAuthHeaders(body),
  })

  if (response.status !== 200) {
    throw new Error(await response.text())
  }

  const blob = await response.blob()

  download(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
}
